import CalendarCloudSetting from '../store/schema/CalendarCloudSetting';
import { CalendarCloudSettingType } from '../store/schema/CalendarCloudSettingType';
import convertSettingsToCalendarCloudSettings from '../utils/convertSettingsToCalendarCloudSettings';
import getCalendarCloudSettingUrl from '../utils/getCalendarCloudSettingUrl';
import { makeGetRequest } from 'owa-ows-gateway';

/**
 * Gets the calendar cloud settings
 */
export default function getCalendarCloudSettingsService(): Promise<CalendarCloudSetting[] | null> {
    const calendarCloudSettings = Object.values(CalendarCloudSettingType).join();
    const calendarCloudSettingsUrl = getCalendarCloudSettingUrl(calendarCloudSettings);

    return makeGetRequest(calendarCloudSettingsUrl).then(calendarCloudSettingsResponse => {
        return convertSettingsToCalendarCloudSettings(calendarCloudSettingsResponse);
    });
}
